var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stationsData && _vm.apparatusData)?_c('div',{attrs:{"id":"homelanding"}},[_c('b-btn',{on:{"click":_vm.generateXml}},[_vm._v("Generate")]),_vm._v(" "+_vm._s(_vm.xmlBuild)+" ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }